import { cva } from 'class-variance-authority';

export const inputVariants = cva(
  [
    'w-full',
    'rounded-lg',
    'border',
    'bg-white',
    'dark:bg-slate-800',
    'text-gray-900',
    'dark:text-slate-100',
    'px-4',
    'py-2',
    'text-base',
    'transition-all',
    'duration-200',
    'placeholder:text-gray-400',
    'dark:placeholder:text-slate-500',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-offset-1',
    'dark:focus:ring-offset-slate-900',
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',
    'disabled:bg-gray-50',
    'dark:disabled:bg-slate-900',
  ],
  {
    variants: {
      inputSize: {
        sm: ['text-sm', 'px-3', 'py-1.5', 'min-h-[32px]'],
        md: ['text-base', 'px-4', 'py-2', 'min-h-[40px]'],
        lg: ['text-lg', 'px-5', 'py-3', 'min-h-[48px]'],
      },
      variant: {
        default: [
          'border-gray-300',
          'dark:border-slate-600',
          'focus:border-primary-500',
          'focus:ring-primary-500',
        ],
        error: ['border-red-500', 'focus:border-red-500', 'focus:ring-red-500'],
        success: ['border-green-500', 'focus:border-green-500', 'focus:ring-green-500'],
      },
    },
    defaultVariants: {
      inputSize: 'md',
      variant: 'default',
    },
  }
);
